document.addEventListener('DOMContentLoaded', function() {
  // Function to initialize thumbnail functionality
  function initThumbnailFunctionality() {
    const thumbnails = document.querySelectorAll('.wt-product__gallery .thumbs-list-item');
    const mainSlides = document.querySelectorAll('.wt-product__gallery .swiper-slide[data-swiper-slide]');
    const mainImages = document.querySelectorAll('.wt-product__gallery .wt-product__img');
    
    if (thumbnails.length === 0) return;
    
    thumbnails.forEach((thumbnail, index) => {
      // Remove existing listeners to avoid duplicates
      thumbnail.removeEventListener('click', handleThumbnailClick);
      
      // Add click listener
      thumbnail.addEventListener('click', handleThumbnailClick);
      
      function handleThumbnailClick(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Get media ID from thumbnail
        const mediaId = thumbnail.getAttribute('data-slide-media-id');
        if (!mediaId) return;
        
        // Remove active class from all thumbnails
        thumbnails.forEach(t => t.classList.remove('swiper-slide-thumb-active'));
        
        // Add active class to clicked thumbnail
        thumbnail.classList.add('swiper-slide-thumb-active');
        
        // Find and show corresponding main slide
        mainSlides.forEach(slide => {
          const slideMediaId = slide.getAttribute('data-media-id');
          if (slideMediaId === mediaId) {
            // Try to click the slide or trigger swiper navigation
            const slideImg = slide.querySelector('.wt-product__img');
            if (slideImg) {
              slideImg.click();
            }
            
            // Alternative: try to navigate swiper to this slide
            const swiperContainer = slide.closest('.swiper');
            if (swiperContainer && swiperContainer.swiper) {
              const slideIndex = Array.from(mainSlides).indexOf(slide);
              swiperContainer.swiper.slideTo(slideIndex);
            }
          }
        });
      }
    });
  }
  
  // Initialize immediately
  initThumbnailFunctionality();
  
  // Re-initialize after any dynamic content changes
  const observer = new MutationObserver(function(mutations) {
    initThumbnailFunctionality();
  });
  
  // Observe the gallery for changes
  const gallery = document.querySelector('.wt-product__gallery');
  if (gallery) {
    observer.observe(gallery, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }
  
  // Also re-initialize after a delay (for swiper initialization)
  setTimeout(initThumbnailFunctionality, 1000);
  setTimeout(initThumbnailFunctionality, 2000);
});
